/** Réglages du fond Manettes (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    nombre: {
        type: "nombre", libelle: "Nombre de manettes", min: 6, max: 30, pas: 1, defaut: 18,
        aide: "Dessinées ou images de la galerie : toutes comptent. Chaque manette est animée deux fois.",
    },
    vitesse: {
        type: "nombre", libelle: "Vitesse de défilement", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    grille: {
        type: "interrupteur", libelle: "Grille en arrière-plan", defaut: true,
        aide: "Le quadrillage discret du fond violet.",
    },
};
